/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createSavingsBalance} from '../api'

export const useMutationCreateSavingsBalance = createReactQueryMutationHook('createSavingsBalance', createSavingsBalance)
